import * as Yup from "yup";

export const BasicImportSchema = Yup.object().shape({
  data_file: Yup.mixed()
    .label("Import File")
    .required()
    .test('fileType', "The data file field must be a file of type: csv, xls, xlsx.", value => SUPPORTED_IMPORT_FORMATS.includes(value.type)),
  mode: Yup.string()
    .label("Mode")
    .nullable(),
});

const SUPPORTED_IMPORT_FORMATS = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "text/plain",
];
